module.exports = __webpack_public_path__ + "img/eu_info.a797fbb8.png";